const heroSwiper = new Swiper('#heroSwiper', {
    loop: true,
    speed: 0,
    effect: 'fade',
    grabCursor: true,
    allowTouchMove: true,
    fadeEffect: {
        crossFade: true
    }
});

// ヒーロー：加速しながら「ちょうど2周」して最後のスライドで静かに着地
// （開始1秒 → 1枚ごとに10%短縮 → 最短0.3秒。枚数が変わっても常に2周で終わる）
(function () {
    if (!heroSwiper || !heroSwiper.slides || heroSwiper.slides.length < 2) return;
    // OSで「視差効果を減らす」設定の人には動かさない
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const START_DELAY = 1000;  // 最初の間隔(ms)
    const FACTOR = 0.90;       // 1枚ごとの短縮率
    const MIN_DELAY = 300;     // これ以上は速くしない(ms)
    const realCount = document.querySelectorAll('#heroSwiper .swiper-slide:not(.swiper-slide-duplicate)').length;
    const TOTAL_STEPS = realCount * 2 - 1;  // ちょうど2周分の切り替え回数（最後のスライドで終わる）
    let delay = START_DELAY;
    let steps = 0;
    function tick() {
        setTimeout(function () {
            heroSwiper.slideNext();
            steps++;
            if (steps >= TOTAL_STEPS) return; // 着地して終了
            delay = Math.max(MIN_DELAY, delay * FACTOR);
            tick();
        }, delay);
    }
    tick();
})();
/*
function updateProgressBar(activeIndex) {
    const allProgress = document.querySelectorAll('.progress-bar__progress');
    const total = 100;
    allProgress.forEach((circle, index) => {
        if (index === activeIndex) {
            // 進捗アニメーション
            circle.style.transition = 'none';
            circle.style.strokeDashoffset = total;
            // 少し遅延してアニメ開始
            setTimeout(() => {
                circle.style.transition = 'stroke-dashoffset 5s linear';
                circle.style.strokeDashoffset = 0;
            }, 50);
        } else {
            // 他はリセット
            circle.style.transition = 'none';
            circle.style.strokeDashoffset = total;
        }
    });
}
*/


/*

const mainSwiper = new Swiper('.thum-swiper', {
    loop: true,
    speed: 1000,
    autoplay: {
        delay: 5000,
        disableOnInteraction: false
    },
    on: {
        slideChangeTransitionStart: function () {
            updateProgressBar(this.realIndex);
        },
        init: function () {
            updateProgressBar(this.realIndex);
        }
    }
});

function updateProgressBar(activeIndex) {
    const allProgress = document.querySelectorAll('.progress-bar__progress');
    const total = 100;
    allProgress.forEach((circle, index) => {
        if (index === activeIndex) {
            // 進捗アニメーション
            circle.style.transition = 'none';
            circle.style.strokeDashoffset = total;
            // 少し遅延してアニメ開始
            setTimeout(() => {
                circle.style.transition = 'stroke-dashoffset 5s linear';
                circle.style.strokeDashoffset = 0;
            }, 50);
        } else {
            // 他はリセット
            circle.style.transition = 'none';
            circle.style.strokeDashoffset = total;
        }
    });
}



const mainSwiper = new Swiper('#heroSwiper', {
  loop: true,
  effect: 'fade',
  speed: 1000,
  autoplay: {
    delay: 5000,
    disableOnInteraction: false
  },
  thumbs: {
    swiper: thumbSwiper
  }
});

*/
                             